import React from 'react'
import styled from 'styled-components'
import { Button, ButtonCircle, ButtonOutline, ButtonTransparent } from 'rebass'

export default styled(({fluid, outline, circle, transparent, secondary, ...others}) =>
  outline
    ? <ButtonOutline {...others} />
    : circle
    ? <ButtonCircle {...others} />
    : transparent
      ? <ButtonTransparent {...others} />
      : <Button {...others} />
)`
  font-size: 1rem;
  font-weight: normal;
  width: ${props => props.fluid && '100%'};
  cursor: pointer;
  background-color: ${props => props.secondary && props.theme.colors.secondary};
  display: flex;
  align-items: center;
  justify-content: center;
  
  :focus {
    box-shadow: none;
  }
`


// WEBPACK FOOTER //
// ./src/components/Button.js